import { z } from 'zod';
import { MY_ITEMS_VIEWS } from './components/my-items-v2/types';

export const HOME_SEARCH_SCHEMA = z.object({
    // Optional so the plain home URL stays clean. When present it deep-links
    // the My items view and wins over the persisted user setting; a malformed
    // value is ignored rather than erroring the route.
    myItems: z.enum(MY_ITEMS_VIEWS).optional().catch(undefined),
});
